"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVaccinationStatus = createVaccinationStatus;
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    vaccinations: {
        id: "dashboard.vaccinations",
        defaultMessage: "Vakcinációk"
    },
    vaccinated: {
        id: "dashboard.vaccinated",
        defaultMessage: "Oltást kapott"
    },
    notVaccinated: {
        id: "dashboard.not_vaccinated",
        defaultMessage: "Oltást nem kapott"
    },
    fluShot: {
        id: "dashboard.flu_shot",
        defaultMessage: "Influenza (1 éven belül)"
    },
    pneumococusVaccination: {
        id: "dashboard.pneumococus_vaccination",
        defaultMessage: "Pneumococcus (5 éven belül)"
    },
    hbvVaccination: {
        id: "dashboard.hbv_vaccination",
        defaultMessage: "HBV"
    },
    havVaccination: {
        id: "dashboard.hav_vaccination",
        defaultMessage: "HAV"
    },
    meningococcusVaccination: {
        id: "dashboard.meningococcus_vaccination",
        defaultMessage: "Meningococcus"
    },
    hpvVaccination: {
        id: "dashboard.hpv_vaccination",
        defaultMessage: "HPV"
    },
    covidVaccination: {
        id: "dashboard.covid_vaccination",
        defaultMessage: "Covid"
    }
};
var YesNo;
(function (YesNo) {
    YesNo["YES"] = "YES";
    YesNo["NO"] = "NO";
})(YesNo || (YesNo = {}));
const groups = [
    {
        label: messages.notVaccinated,
        variant: "dark",
        predicate: (event) => event !== undefined && event.value === YesNo.NO
    },
    {
        label: messages.vaccinated,
        variant: "light",
        predicate: (event) => event !== undefined && event.value === YesNo.YES
    }
];
const values = [
    {
        label: messages.fluShot,
        query: queries_1.queries.fluShot
    },
    {
        label: messages.pneumococusVaccination,
        query: queries_1.queries.pneumococusVaccination
    },
    {
        label: messages.hbvVaccination,
        query: queries_1.queries.hbvVaccination
    },
    {
        label: messages.havVaccination,
        query: queries_1.queries.havVaccination
    },
    {
        label: messages.meningococcusVaccination,
        query: queries_1.queries.meningococcusVaccination
    },
    {
        label: messages.hpvVaccination,
        query: queries_1.queries.hpvVaccination
    },
    {
        label: messages.covidVaccination,
        query: queries_1.queries.covidVaccination
    }
];
function createVaccinationStatus(intl, { events }) {
    const list = (0, shared_1.createGroupList)(intl, { events, groups, values });
    const content = (0, shared_1.createSectionContent)([list]);
    return (0, shared_1.createSection)(intl, { label: messages.vaccinations, content });
}
